import React from "react";

import PageComponent from "components/Page";
import TabsSwitch from "components/TabsSwitch";

import General from "./components/general";
import SMS from "./components/sms";
import PaymentWay from "./components/paymentWay";
import AddPaymentWayDialog from "./components/AddPaymentWay";
import AddPaymentWayToClinicDialog from "./components/AddPaymentWayToClinic";


export default class Settings extends PageComponent {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            currentClinicId: this.state.clinicId
        };
    }

    get dialogsMap() {
        return {
            "addPaymentWay": AddPaymentWayDialog,
            "addPaymentWayToClinic": AddPaymentWayToClinicDialog,
        };
    }

    componentDidLoad() {
        const { tab } = this.state.urlProps;
        const cb = !tab ? null : this.changeTab.bind(this, tab);

        if (cb)
            cb();
    }

    onClinicChanged() {
        const currPage = this.pages[this.tabsView?.tabKey];
        if (currPage?.refresh?.apply)
            currPage.refresh();

        const currentClinicId = this.state.clinicId;
        this.setState({ currentClinicId });
    }

    changeTab(tab) {
        this.tabsView.setTab(tab);
    }

    onTabsChange(tab) {
        if (this._helper.getPageTab() === tab)
            return;

        this._helper.setPageTab(tab || this.tabsView.tabKey);
    }

    renderPage() {
        const { currentClinicId } = this.state;
        const props = {
            parent: this,
            currentClinicId
        };

        this.pages = {};

        return (
            <TabsSwitch
                ref={el => this.tabsView = el}
                className="flex1 minH0"
                links={["general", "paymentway", "sms"]}
                tabs={["client.general", "Способы оплат", "main.sms"]}
                pages={[
                    <General ref={el => this.pages["general"] = el} {...props} />,
                    <PaymentWay ref={el => this.pages["paymentway"] = el} {...props} />,
                    <SMS ref={el => this.pages["sms"] = el} {...props} />,
                ]}
                onBeforeChange={this.onTabsChange.bind(this)}
            />
        );
    }
}
